(function () {

  const BREAKPOINT_TABLET = 1024;
  const BREAKPOINT_MOBILE = 768;



  function initAllSliders() {
    const sliders = document.querySelectorAll('[data-slider]');
    sliders.forEach(initSlider);
  }



  function initSlider(sliderEl) {

    const track       = sliderEl.querySelector('[data-slider-track]');
    const slides      = Array.from(sliderEl.querySelectorAll('[data-slide]'));
    const prevBtn     = sliderEl.querySelector('[data-slider-prev]');
    const nextBtn     = sliderEl.querySelector('[data-slider-next]');
    const progressBar = sliderEl.querySelector('[data-slider-progress]');
    const controls    = sliderEl.querySelector('[data-slider-controls]');

    let currentIndex  = 0;
    let isSliderMode  = false;   
    let resizeTimer   = null;

    function getVisibleCount() {
      const vw = window.innerWidth;
      if (vw <= BREAKPOINT_MOBILE) return 1;
      if (vw <= BREAKPOINT_TABLET) return 2;
      return slides.length; 
    }

    function getGap() {
      const raw = getComputedStyle(track).gap || getComputedStyle(track).columnGap || '0px';
      return parseFloat(raw) || 0;
    }

    function getSlideWidth() {
      return slides[0] ? slides[0].offsetWidth : 0;
    }

    function getMaxIndex() {
      const visible = getVisibleCount();
      return Math.max(0, slides.length - visible);
    }

    function updateTrackPosition() {
      if (!isSliderMode) return;
      const offset = currentIndex * (getSlideWidth() + getGap());
      track.style.transform = `translateX(-${offset}px)`;
    }

    function updateProgress() {
      const max = getMaxIndex();
      const pct = max === 0 ? 100 : (currentIndex / max) * 100;
      progressBar.style.width = `${pct}%`;
    }

    function updateArrows() {
      prevBtn.disabled = currentIndex === 0;
      nextBtn.disabled = currentIndex >= getMaxIndex();
    }

    function render() {
      updateTrackPosition();
      updateProgress();
      updateArrows();
    }

    function slideNext() {
      if (currentIndex < getMaxIndex()) {
        currentIndex += 1;
        render();
      }
    }

    function slidePrev() {
      if (currentIndex > 0) {
        currentIndex -= 1;
        render();
      }
    }


    function enterSliderMode() {
      if (isSliderMode) return;
      isSliderMode = true;

      track.style.transition = '';

      render();
    }

    function exitSliderMode() {
      if (!isSliderMode) return;
      isSliderMode = false;
      currentIndex = 0;

      track.style.transition = 'none';
      track.style.transform  = 'translateX(0)';

      progressBar.style.width = '0%';
      prevBtn.disabled = true;
      nextBtn.disabled = false;
    }

    
    function syncMode() {
      const vw = window.innerWidth;

      if (vw <= BREAKPOINT_TABLET) {
        enterSliderMode();
      } else {
        exitSliderMode();
      }
    }


    let touchStartX = 0;
    let touchEndX   = 0;
    const SWIPE_THRESHOLD = 50; 

    sliderEl.addEventListener('touchstart', function (e) {
      touchStartX = e.changedTouches[0].screenX;
    }, { passive: true });

    sliderEl.addEventListener('touchend', function (e) {
      touchEndX = e.changedTouches[0].screenX;
      const delta = touchStartX - touchEndX;

      if (Math.abs(delta) < SWIPE_THRESHOLD) return; 

      if (delta > 0) {
        slideNext(); 
      } else {
        slidePrev(); 
      }
    }, { passive: true });


    sliderEl.addEventListener('keydown', function (e) {
      if (!isSliderMode) return;
      if (e.key === 'ArrowLeft')  { e.preventDefault(); slidePrev(); }
      if (e.key === 'ArrowRight') { e.preventDefault(); slideNext(); }
    });

    function onResize() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        syncMode();
        if (isSliderMode) {
          currentIndex = Math.min(currentIndex, getMaxIndex());
          track.style.transition = 'none';
          updateTrackPosition();

          requestAnimationFrame(function () {
            requestAnimationFrame(function () {
              track.style.transition = '';
              updateProgress();
              updateArrows();
            });
          });
        }
      }, 150);
    }

    window.addEventListener('resize', onResize);

    nextBtn.addEventListener('click', slideNext);
    prevBtn.addEventListener('click', slidePrev);

    syncMode();

  } 


  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllSliders);
  } else {
    initAllSliders();
  }

  document.addEventListener('shopify:section:load', function (e) {
    const section = e.target;
    const slider  = section.querySelector('[data-slider]');
    if (slider) initSlider(slider);
  });

})();